import isEmpty from 'lodash/isEmpty';

import { CompanyMessage } from '../../../types/CompanyMessage';
import { getRole } from '../hooks/useRole';

type NamedCompany = Pick<CompanyMessage, 'id' | 'name' | 'internalName'>;

const getCompanyDisplayName = (company: NamedCompany): string => {
    const role = getRole();

    if (!company.internalName || !role) {
        return company.name;
    }

    if (role.isSuperAdmin()) {
        return company.internalName;
    }

    if (role.getCompany(company.id)) {
        return company.internalName;
    }

    return company.name;
};

interface FormatCompanyNameConfig {
    company?: NamedCompany;
    forcePublicName?: boolean;
}

export const formatCompanyName = ({ company, forcePublicName = false }: FormatCompanyNameConfig) => {
    if (!company) {
        return null;
    }

    if (typeof company !== 'object' || isEmpty(company)) {
        return null;
    }

    return forcePublicName ? company.name : getCompanyDisplayName(company);
};
